import { ColorSwatch } from "@mantine/core";
import { IconHelp } from "@tabler/icons-react";
import classNames from "classnames";

export enum StatusSymbolColor {
  Red = "var(--mantine-color-error-filled)",
  Green = "var(--mantine-color-success-filled)",
  Warning = "var(--mantine-color-warning-4)"
}

interface StatusSymbolProps {
  color?: string;
  noStatus?: boolean;
}

function StatusSymbol({ color = "#000", noStatus = false }: StatusSymbolProps) {
  if (noStatus) {
    return <IconHelp color="#000" size={24} test-id="StatusSymbol" />;
  }

  return (
    <ColorSwatch
      className={classNames("StatusSymbol", {
        red: color === StatusSymbolColor.Red,
        green: color === StatusSymbolColor.Green,
        warning: color === StatusSymbolColor.Warning
      })}
      color={color}
      data-testid="StatusSymbol"
      mr="xs"
      size={16}
      test-id="StatusSymbol"
    />
  );
}

export { StatusSymbol };
